export default {
  Title: 'Phục hồi dữ liệu đã xóa',
  SubTitle: 'Chức năng này chỉ có thể phục hồi chứng từ đã xóa trong khoảng 30 ngày trở lại.',
  ActionTitle: 'Phục hồi chứng từ đã xóa'
};
